import { contactFormBody } from '@/stores/contactFormStore';
import { useRecoilState } from 'recoil';
import TextField from '../TextField';

export default function BodyField() {
  const [body, setBody] = useRecoilState(contactFormBody);
  return (
    <TextField
      placeHolder="How can we help you?"
      value={body}
      onChange={setBody}
      className="mt-4"
      maxLength={2000}
      multiline
    />
  );
}
